import { FormGroup, Validators } from "@angular/forms"
import { LayerType, sharedForms } from "../layer.model"
import { FormType, Properties, ZoneProperties } from "../properties.model"
import { Subject } from "rxjs"
import { generateBuildingOptions } from "../../../services/image-data.utils"

export const zonesForm: Properties = {
  propertyType: LayerType.Zones,
  label: 'Zones Layer',
  forms:
    sharedForms.concat([
    {
      id: ZoneProperties.ZoneGroup,
      label: 'Building Groups',
      type: FormType.Multiselect,
      hint: "These are defined in the RenderSettings ModuleScript within Roblox Studio.",
      placeholder: 'Building Groups',
    },
    {
      id: ZoneProperties.ZoneDetail,
      label: 'Level of Detail',
      type: FormType.SliderNumber,
      hint: "How aggressively the zone will conform the contour of the selected buildings",
      defaultValue: 0,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: ZoneProperties.ZoneOffset,
      label: 'Offset',
      type: FormType.SliderNumber,
      hint: "Scale the zone to give offset from the actual structures.",
      defaultValue: 0,
      sliderOptions: {
        min: .05,
        max: 1,
        step: 0.01
      }
    },
    {
      id: ZoneProperties.ZoneFillEnabled,
      label: 'Fill Enabled',
      type: FormType.Checkbox,
      defaultValue: true,
    },
    {
      id: ZoneProperties.ZoneFillColor,
      label: 'Fill Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: ZoneProperties.ZoneFillOpacity,
      label: 'Fill Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: ZoneProperties.ZoneStrokeEnabled,
      label: 'Stroke Enabled',
      type: FormType.Checkbox,
      defaultValue: false,
    },
    {
      id: ZoneProperties.ZoneStrokeWidth,
      label: 'Stroke Width',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: ZoneProperties.ZoneStrokeColor,
      label: 'Stroke Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: ZoneProperties.ZoneStrokeOpacity,
      label: 'Fill Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: ZoneProperties.ZoneStokeDashed,
      label: 'Dashed',
      type: FormType.Checkbox,
      defaultValue: false,
    },
    {
      id: ZoneProperties.ZoneStokeDashedLength,
      label: 'Dash Length',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: .01,
        max: 1,
        step: 0.01
      }
    },
  ]),
  changeHandler: (fg: FormGroup, formChanged: Subject<void>) => {},
  onInit: (data ) => {
    const selector = zonesForm.forms.find(form => form.id === ZoneProperties.ZoneGroup)
    if (selector) {
      selector.options = generateBuildingOptions(data.stringEncodings)
      const intitalOption = selector.options.find(option => option.value === 1)
      if (intitalOption) {
        selector.defaultValue = [intitalOption]
      }
    }
  }
}
